import React from 'react';
import Notes from 'Components/Notes';

export default function NotesSection ({notes}) {
  if (!notes) return null;

  return (
    <section className={'scene_section'}>
      <header>Notes</header>
      <Notes text={notes} disabled />
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/app/Scenes/OilManufacturer/brand/Application/Details/NotesSection.jsx